import { useRef } from "react";
import { InputRef } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ColumnType, FilterConfirmProps } from "antd/lib/table/interface";

import ColumnSearchField from "components/elements/ColumnSearchField";

function useSearchColumn<T>() {
  const searchInputRef = useRef<InputRef>(null);

  const handleSearch = (confirm: (param?: FilterConfirmProps) => void) => {
    confirm();
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
  };

  const getColumnSearchProps = (dataIndex: keyof T): ColumnType<T> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <ColumnSearchField
        ref={searchInputRef}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        handleSearch={handleSearch}
        confirm={confirm}
        clearFilters={clearFilters}
        handleReset={handleReset}
      />
    ),
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) =>
      `${record[dataIndex]}`
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current?.select(), 100);
      }
    },
  });
  return getColumnSearchProps;
}

export default useSearchColumn;
